import { Action } from 'redux';
import { Data } from './types';

export const UPDATE_CART_REQUEST = 'UPDATE_CART_REQUEST';
export const UPDATE_CART_SUCCESS = 'UPDATE_CART_SUCCESS';
export const UPDATE_CART_ERROR = 'UPDATE_CART_ERROR';

export const FETCH_LIST_CART_REQUEST = 'FETCH_LIST_CART_REQUEST';
export const FETCH_LIST_CART_SUCCESS = 'FETCH_LIST_CART_SUCCESS';
export const FETCH_LIST_CART_ERROR = 'FETCH_LIST_CART_ERROR';

export const UPDATE_CART_LIST = 'UPDATE_CART_LIST';

export const FETCH_COUNT_CART_REQUEST = 'FETCH_COUNT_CART_REQUEST';
export const FETCH_COUNT_CART_SUCCESS = 'FETCH_COUNT_CART_SUCCESS';
export const FETCH_COUNT_CART_ERROR = 'FETCH_COUNT_CART_ERROR';

export const RESET_COUNT_CART = 'RESET_COUNT_CART';

export interface FetchDataAction extends Action<typeof UPDATE_CART_REQUEST> {
    payload: any;
}
export interface FetchDataSuccessAction extends Action<typeof UPDATE_CART_SUCCESS> {
    payload: Data[];
}

export interface FetchDataErrorAction extends Action<typeof UPDATE_CART_ERROR> {
    payload: Error;
}

export interface FetchListDataAction extends Action<typeof FETCH_LIST_CART_REQUEST> {
    payload: any;
}
export interface FetchListDataSuccessAction extends Action<typeof FETCH_LIST_CART_SUCCESS> {
    payload: Data[];
}

export interface FetchListDataErrorAction extends Action<typeof FETCH_LIST_CART_ERROR> {
    payload: Error;
}

export const updateCartRequest = (data: any): FetchDataAction => ({
    type: UPDATE_CART_REQUEST,
    payload: data,
});

export const updateCartSuccess = (data: any): FetchDataSuccessAction => ({
    type: UPDATE_CART_SUCCESS,
    payload: data,
});

export const updateCartError = (error: any): FetchDataErrorAction => ({
    type: UPDATE_CART_ERROR,
    payload: error,
});


export const fetchListCartRequest = (data: any): FetchListDataAction => ({
    type: FETCH_LIST_CART_REQUEST,
    payload: data,
});

export const fetchListCartSuccess = (data: any): FetchListDataSuccessAction => ({
    type: FETCH_LIST_CART_SUCCESS,
    payload: data,
});

export const fetchListCartError = (error: any): FetchListDataErrorAction => ({
    type: FETCH_LIST_CART_ERROR,
    payload: error,
});

export const updateCartList = (
    data: any
): { payload: any; type: string } => ({
    type: UPDATE_CART_LIST,
    payload: data,
});

export const fetchCountCartRequest = (): { type: string } => ({
    type: FETCH_COUNT_CART_REQUEST,
});

export const fetchCountCartSuccess = (
    data: any
): { payload: any; type: string } => ({
    type: FETCH_COUNT_CART_SUCCESS,
    payload: data,
});

export const fetchCountCartError = (
    error: any
): { payload: any; type: string } => ({
    type: FETCH_COUNT_CART_ERROR,
    payload: error,
});

export const resetCountCart = () => ({
  type: RESET_COUNT_CART,
});